import actionTypes from 'redux/actions/actionTypes'

const defaultState = {
	open: false,
	slideId: 0,
	selected: 1,
	list: [],
}

function initialize(state, action) {
	const newState = {...state}
	newState.slideId = action.slideId
	return newState
}

function setAll(state, action) {
	const newState = {...state}
	newState.list = [...action.payload.list]
	newState.selected = action.payload.selected
	return newState
}

function toggleMenu(state) {
	const newState = {...state}
	newState.open = !state.open
	return newState
}

function themeChangeSuccess(state, action) {
	const newState = {...state}
	newState.selected = action.themeId
	return newState
}

const themesReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.THEMES_INITIALIZE: return initialize(state, action)
		case actionTypes.THEMES_SET_ALL: return setAll(state, action)
		case actionTypes.THEMES_TOGGLE_MENU: return toggleMenu(state)
		case actionTypes.THEMES_CHANGE_SUCCESS: return themeChangeSuccess(state, action)
		default: return state
	}
}

export default themesReducer
